/**
 * The capabilities a partner admin can withhold from a standard user. Mirrors the
 * backend registry: the API returns a user's effective list as these strings, and
 * a key the backend does not know is refused on save.
 */
export const PERMISSION_KEYS = [
  "orders.create",
  "orders.cancel",
  "orders.decide_requests",
  "catalog.manage",
  "catalog.activate_products",
  "campaigns.manage",
] as const;

export type PermissionKey = typeof PERMISSION_KEYS[number];

export function isPermissionKey(value: unknown): value is PermissionKey {
  return (
    typeof value === "string" &&
    (PERMISSION_KEYS as readonly string[]).includes(value)
  );
}
